<template>
  <div v-if="status > 0 && status < 10">
    <div class="login-alert p-3 text-center mt-4">
      <div class="text-primary">Внимание!</div>
      <span>Документ принят! После проверки с вами свяжется менеджер.</span>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-sm-12 col-md-auto sign-list-type mt-4">
      <div class="list-sign">
        <div v-if="show.includes('podpislon')" class="form-group mb-3">
          <label :for="'typeSms'">
            <input
              type="radio"
              name="typeSign"
              :id="'typeSms'"
              :checked="type == 'podpislon'"
              @change="() => onTypeChange('podpislon')"
              :disabled="disabled"
            />
            <span>Сервис Подпислон (по SMS)</span>
          </label>
        </div>

        <div v-if="show.includes('fns')" class="form-group mb-3">
          <label :for="'typeFns'">
            <input
              type="radio"
              name="typeSign"
              :id="'typeFns'"
              :checked="type == 'fns'"
              @change="() => onTypeChange('fns')"
              :disabled="disabled"
            />
            <span>ЭЦП ФНС России</span>
          </label>
        </div>

        <div v-if="show.includes('nopaper')" class="form-group mb-3">
          <label :for="'typeNopaper'">
            <input
              type="radio"
              name="typeSign"
              :id="'typeNopaper'"
              :checked="type == 'nopaper'"
              @change="() => onTypeChange('nopaper')"
              :disabled="disabled"
            />
            <span>Сервис Nopaper</span>
          </label>
        </div>

        <div v-if="show.includes('print')" class="form-group mb-3">
          <label :for="'typePrint'">
            <input
              type="radio"
              name="typeSign"
              :id="'typePrint'"
              :checked="type == 'print'"
              @change="() => onTypeChange('print')"
              :disabled="disabled"
            />
            <span
              >Печатный документ
              <div style="color: #999; font-size: 12px">
                Не рекомендовано
              </div></span
            >
          </label>
        </div>
      </div>
    </div>

    <div v-if="type === 'podpislon'" class="col-sm-12 col-lg-auto mt-4">
      <Podpislon
        :uid="props.uid"
        :inn="props.inn"
        :phone="props.phone"
        :getFile="props.getFile"
        :setStatus="setStatus"
      />
    </div>
    <div v-else-if="type === 'fns'" class="col-sm-12 col-lg-auto mt-4">
      <Fns
        :uid="props.uid"
        :inn="props.inn"
        :phone="props.phone"
        :getFile="props.getFile"
        :setStatus="setStatus"
      />
    </div>
    <div v-else-if="type === 'nopaper'" class="col-sm-12 col-lg-auto mt-4">
      <NoPaper
        :uid="props.uid"
        :inn="props.inn"
        :phone="props.phone"
        :getFile="props.getFile"
        :setStatus="setStatus"
      />
    </div>
    <div v-else class="col-sm-12 col-lg-auto mt-4">
      <Print
        :uid="props.uid"
        :getFile="props.getFile"
        :title="props.title"
        :setStatus="setStatus"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

import "./style.css";

import { useStore } from "vuex";
const store = useStore();

import { useRoute } from "vue-router";
const route = useRoute();

import Print from "./print.vue";
import NoPaper from "./nopaper.vue";
import Podpislon from "./podpislon.vue";
import Fns from "./fns.vue";

const props = defineProps({
  phone: String,
  inn: String,
  uid: String,
  getFile: {
    type: Function,
    default: () => false,
  },
  title: {
    type: String,
    default: "No Name",
  },
  show: {
    type: Array,
    default: () => ["print"],
  },
  default: {
    type: String,
    default: "print",
  },
  status: {
    type: Number,
    default: 0,
  },
});

const disabled = computed(() => props.status > 0);

const status = ref(props.status);

const setStatus = (value) => {
  status.value = value;
};

const type = ref(props.default);

const onTypeChange = (item) => {
  type.value = item;
};
</script>